import React from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import PropTypes from "prop-types";
import { getFieldTypeId, getListType } from "./form-automation-util";
import { FluentTooltip } from "../../../../../../../components/FluentUI/Fluent-Tooltip";

export const DropDownCellColumn = (props) => {
  const [data, setData] = React.useState({
    allData: [],
    filteredData: [],
    isLoading: true,
  });
  const [value, setValue] = React.useState(null);

  React.useEffect(() => {
    let dataForDropdown = [];
    if (props?.list) {
      dataForDropdown = Object.entries(props.list[getListType(props.field)])
        .filter((item) => item[1] !== null)
        .map(([id, text]) => ({
          id,
          text,
        }));
      const gridItemId = props.dataItem[getFieldTypeId(props.field)];
      const ddValue = dataForDropdown.filter(
        (element) => element.id.toString() === gridItemId?.toString()
      )[0];

      setData((prev) => ({
        ...prev,
        allData: dataForDropdown.slice(),
        filteredData: dataForDropdown.slice(),
        isLoading: false,
      }));
      setValue(ddValue);
    }
    if (props.field === "DynamicFieldColumnName") {
      console.log("Filter Columns -->");
    }
  }, []);

  const handleChange = (e) => {
    if (e.target.value !== null) {
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
      setValue(e.target.value);
    } else {
      setValue(null);
    }
  };

  const filterData = (filter) => {
    return filterBy(data?.allData, filter);
  };

  const filterChange = (event) => {
    setData((prev) => ({
      ...prev,
      filteredData: filterData(event.filter),
    }));
  };

  return !props.dataItem?.inEdit ? (
    <FluentTooltip
      target={
        <td className="k-table-td">
          {value === null ? "" : value?.text?.toString()}
        </td>
      }
      text={value === null ? "" : value?.text?.toString()}
    ></FluentTooltip>
  ) : (
    <td className="k-table-td">
      <ComboBox
        data={data?.filteredData}
        textField="text"
        valueField="id"
        filterable={true}
        onFilterChange={filterChange}
        onChange={handleChange}
        value={value}
        title={value === null ? "" : value?.text?.toString()}
      />
    </td>
  );
};

DropDownCellColumn.propTypes = {
  dataItem: PropTypes.object,
  field: PropTypes.string,
  list: PropTypes.object,
  onChange: PropTypes.func,
};
